// extracted by mini-css-extract-plugin
module.exports = {"list-item":"style_list-item__3u8s9","info":"style_info__2zIsa","name":"style_name__3QNA6","code":"style_code__3BLxd","right-icon-wrap":"style_right-icon-wrap__asCYg"};